import { render, staticRenderFns } from "./dialog-address.vue?vue&type=template&id=827959a8&"
import script from "./dialog-address.vue?vue&type=script&lang=js&"
export * from "./dialog-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports